import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type CustomerFavoriteProducts } from '../../../../../../src/types/CustomerFavoriteProducts';
export { type CustomerFavoriteProducts } from '../../../../../../src/types/CustomerFavoriteProducts';

export type GetFavoriteProductsParams = {
  customerId: number;
};

export const getFavoriteProductsPath = ({
  customerId,
}: GetFavoriteProductsParams) =>
  `/api/v2/customers/${customerId}/favorite_products/`;

export async function getApiV2CustomersCustomerIdFavoriteProducts({
  customerId,
}: GetFavoriteProductsParams) {
  return await send<CustomerFavoriteProducts>({
    path: getFavoriteProductsPath({ customerId }),
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
